import { Component, ViewChild } from "@angular/core";
import {
  MatSnackBar,
  MatPaginator,
  MatTableDataSource
} from "@angular/material";
import { Inscricao } from "../inscricao/inscricao";
import { InscricaoListComponent } from "../inscricao-list/inscricao-list.component";

@Component({
  templateUrl: "./inscricao-admin.component.html",
  selector: "inscricao-admin",
  styleUrls: ["./inscricao-admin.component.css"]
})
export class InscricaoAdminComponent {
  @ViewChild(InscricaoListComponent) inscricaoListComponent: InscricaoListComponent;
  public filtro: Inscricao;

  // construtor
  constructor( ) {

  }

  filtroEmitido(filtro: Inscricao){
    this.filtro = filtro;
    this.inscricaoListComponent.buscar(filtro);
  }


}
